import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationWarningDialogData } from '../../../models/confirmation-warning-dialog-data';

@Component({
  selector: 'app-confirmation-warning-dialog',
  templateUrl: './confirmation-warning-dialog.component.html',
  standalone: false
})
export class ConfirmationWarningDialogComponent {
  dialogData: ConfirmationWarningDialogData;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ConfirmationWarningDialogData
  ) {
    if (data) {
      this.dialogData = data;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
